// src/components/ItemCardSingleModal/index.jsx
import { createRoot } from "react-dom/client";
import ItemCardSingle from "./ItemCardSingle";
import { fetchItems } from "../../utils/fetchItems"; // 共通のfetchItems関数をインポート
import { trackButtonClick } from "../../utils/ItemCardClickedAnalytics"; // 追加

let root;

document.addEventListener("DOMContentLoaded", () => {
 const buttons = document.querySelectorAll("button[data-item-inhouse-code]");
 buttons.forEach((button) => {
  button.addEventListener("click", async () => {
   const itemInhouseCode = button.getAttribute("data-item-inhouse-code");
   await ItemCardSingleModal(itemInhouseCode);
  });
 });
});

async function ItemCardSingleModal(itemInhouseCode) {
 const modalContainer = document.getElementById("item_card_modal");
 if (!root) {
  root = createRoot(modalContainer);
 } else {
  root.unmount();
  root = createRoot(modalContainer);
 }

 try {
  const data = await fetchItems();
  const selectedItem = data.find((i) => i.item_inhouse_code.toString() === itemInhouseCode);
  if (!selectedItem) {
   //    console.error(`Item with item_inhouse_code ${itemInhouseCode} not found`);
   return;
  }

  // イベントトラッキングを実施
  trackButtonClick(selectedItem.item_inhouse_code, selectedItem.item_number, selectedItem.item_color_en);

  root.render(<ItemCardSingle item={selectedItem} />);
 } catch (error) {
  console.error("Error:", error);
 }
}

export default ItemCardSingleModal;
